"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgMessageHeavy(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M20.125 3.75c1.064 0 1.95.822 2.102 1.908l.017.157.006.164v11.875c0 1.11-.778 2.044-1.818 2.205l-.15.018-.157.006H3.875c-1.064 0-1.95-.822-2.102-1.908l-.017-.157-.006-.164V5.98c0-1.11.778-2.044 1.818-2.205l.15-.018.157-.006h16.25zM3.499 9.979l.001 7.616c0 .344.233.638.544.724l.096.019.101.007 15.509.185a.751.751 0 00.725-.55l.019-.097.006-.103-.001-7.8-4.094 3.225c-.235.192-.858.707-1.103.896-1.185.913-2.216 1.406-3.3 1.4-1.003.005-1.964-.416-3.034-1.196l-.249-.186c-.304-.234-1.141-.93-1.209-.983L3.5 9.979zM19.75 5.5H4.25a.751.751 0 00-.725.551l-.019.097-.006.102-.001 1.264L5.49 9.105l4.001 3.15c.188.148.348.271.508.39.32.235.61.43.885.584.445.25.822.38 1.12.376.29.004.667-.126 1.112-.376a8.63 8.63 0 00.886-.585l.327-.249 5.397-4.257.773-.623.001-1.265a.75.75 0 00-.75-.75z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgMessageHeavy;
exports.default = _default;